import { render } from "./BaseTextarea.vue?vue&type=template&id=1a5afde8&scoped=true"
import script from "./BaseTextarea.vue?vue&type=script&lang=js"
export * from "./BaseTextarea.vue?vue&type=script&lang=js"

import "./BaseTextarea.vue?vue&type=style&index=0&id=1a5afde8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5afde8"]])

export default __exports__